module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteFxRateDialog.title":"Delete FX Rate","deleteFxRateDialog.subtitle":"Warning: This process is irreversible! Your FX Rate data will be deleted permanently and you will need to re-enter your rates if you want to see your data again. Changes will only take place on the next import."}}')
  delete Component.options._Ctor
}
